module.exports = __webpack_public_path__ + "static/media/vs-code.1f5d1f79.png";